import SelectRedux from "components/molecules/SelectRedux";
import DateRangePickerRedux from "components/molecules/DateRangePickerRedux";
import PageSize from "components/organisms/PageSize";
import { pageSize } from "utils/normalize.util";
import SelectYeloDriver from "components/organisms/SelectYeloDriver";
import SelectSearchVehicle from "components/organisms/SelectSearchVehicle";
import SelectSearchPartner from "components/organisms/SelectSearchPartner";
import { dateRangeFilter } from "utils/validate.util";

export { default } from "./ECarsFilters";

// Mirrors what api/v2/controllers/ecar.controller.js -> getFilteredECars
// actually supports: driver_id, vehicle_id, partner_id, status and a
// taken_time range.
export const fields: any[] = [
  {
    name: "driver_id",
    label: "Driver",
    component: SelectYeloDriver,
    cellProps: { sm: 6, md: 3 },
    ComboBoxProps: {
      multiple: false,
      options: [],
    },
  },
  {
    name: "vehicle_id",
    label: "Vehicle",
    component: SelectSearchVehicle,
    cellProps: { sm: 6, md: 3 },
    ComboBoxProps: {
      multiple: false,
      options: [],
    },
  },
  // {
  //     name: "partner_id",
  //     label: "Partner",
  //     component: SelectSearchPartner,
  //     cellProps: { sm: 6, md: 3 },
  //     ComboBoxProps: {
  //         multiple: false,
  //         options: [],
  //     },
  // },
  {
    name: "date",
    label: "Taken Date Range",
    validate: [dateRangeFilter],
    component: DateRangePickerRedux,
    cellProps: { md: 6 },
    DateRangePickerProps: {
      onChange: () => {},
      InputFieldProps: {},
      value: { date: ["", ""], error: ["", ""] },
    },
  },
  {
    name: "status",
    label: "Status",
    component: SelectRedux,
    cellProps: { sm: 6, md: 3 },
    SelectProps: {
      options: [
        { value: "active", label: "Active" },
        { value: "returned", label: "Returned" },
      ],
    },
  },
  {
    name: "page_size",
    label: "Page Size",
    normalize: pageSize,
    component: PageSize,
    cellProps: { sm: 6, md: 3 },
    PageSizeProps: { form: "ECarsFiltersForm" },
  },
];
